import { render, staticRenderFns } from "./DuelsGameUsers.vue?vue&type=template&id=cd104a40&scoped=true"
import script from "./DuelsGameUsers.vue?vue&type=script&lang=js"
export * from "./DuelsGameUsers.vue?vue&type=script&lang=js"
import style0 from "./DuelsGameUsers.vue?vue&type=style&index=0&id=cd104a40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd104a40",
  null
  
)

export default component.exports